import React, { useEffect, useMemo, useState } from "react";
import Navbar from "./Navbar.js";
import Sidebar from "./SIdebar.js";
import Products from "../screens/Products.js";
import UserDashboard from "../screens/UserDashboard.js";
import AddProduct from "../screens/AddProduct.js";
import Breadcrumb from "./Breadcrumb"; // Import Breadcrumb
import {
  FaHome,
  FaBox,
  FaPlus,
  FaBalanceScale,
  FaBuilding,
  FaUserTie,
  FaTags,
  FaLocationArrow,
  FaUsers,
  FaRecycle,
  FaIndustry,
  FaFirstOrder,
  FaShopify,
  FaFileInvoiceDollar,
  FaExchangeAlt,
  FaTruck,
  FaReceipt,
  FaArrowsAltV,
  FaWarehouse,
  FaHandHoldingUsd,
  FaClipboardCheck,
  FaHandHolding,
  FaArrowCircleDown,
  FaShoppingCart,
  FaPeopleCarry, 
  FaCreditCard
} from "react-icons/fa"; // Import icons
import { LiaFileInvoiceDollarSolid } from "react-icons/lia"
import { MdOutlinePayments } from "react-icons/md";
import { IoReceiptOutline, IoSettings } from "react-icons/io5";
import Units from "../screens/Units";
import AddUnit from "../screens/AddUnit";
import Organizations from "../screens/Organizations";
import AddOrganization from "../screens/AddOrganization";
import Customers from "../screens/Customers";
import AddCustomer from "../screens/AddCustomer";
import ProductCateogry from "../screens/ProductCategory.js";
import AddProductCategory from "../screens/AddProductCategory.js";
import Location from "../screens/Location.js";
import AddLocation from "../screens/AddLocations.js";
import Users from "../screens/Users.js";
import AddUser from "../screens/AddUser.js";
import ProductBatch from "../screens/ProductBatch.js";
import { useNavigate } from "react-router-dom";
import OrderCycle from "../screens/OrderCycle.js";
import CreateNewOrderCycle from "../screens/CreateNewOrderCycle.js";
import { useCallback } from "react";
import OrderRequest from "../screens/OrderRequest.js";
import { jwtDecode } from "jwt-decode";
import UserProfile from "../screens/UserProfile.js";
import SalesOrderInvoicing from "../screens/SalesOrderInvoicing.js";
import SalesOrders from "../screens/SalesOrders.js"
import Invoices from "../screens/Invoice.js"
import TransferOrders from "../screens/TransferOrder.js";
import AddProductionBatch from "../screens/AddProductionBatch.js";
import AddTransferOrder from "../screens/AddTransferOrder.js";
import AddOrderRequest from "../screens/AddOrderRequest.js";
import AddLocationCategory from "../screens/AddLocationCategory.js";
import TransportOrders from "../screens/TransportOrder.js";
import AddTransportOrder from "../screens/AddTransportOrder.js";
import TransferOrderReceipts from "../screens/TransferOrderReceipts.js";
import AddAdjustmentCategory from "../screens/AddAdjustmentCategory.js";
import PaymentReceipts from "../screens/PaymentReceipts.js";
import AddPaymentReceipts from "../screens/AddPaymentReceipts.js";
import Settlements from "../screens/Settlements.js"
import AddSettelments from "../screens/AddSettelments.js";
import StockAdjustment from "../screens/StockAdjustment.js";
import AddStockAdjustment from "../screens/AddStockAdjustment.js";
import StockView from "../screens/StockView.js";
import Settings from "../screens/Settings.js";
import DispatchedStockOnLoan from "../screens/DispatchedStockOnLoan.js";
import AddDispatchedStockOnLoan from "../screens/AddDispatchStockOnLoan.js";
import ReceivedStockOnLoan from "../screens/ReceivedStockOnLoan.js";
import AddReceivedStockOnLoan from "../screens/AddReceivedStockOnLoan.js";
import IncomingStockOnLoan from "../screens/IncomingStockOnLoan.js";
import AddSupplier from "../screens/AddSupplier.js";
import AddPurchaseOrder from "../screens/AddPurchaseOrder.js";
import AddGRN from "../screens/AddGRN.js";
import GoodReceiptNote from "../screens/GoodReceiptNote.js";
import PurchaseOrders from "../screens/PurchaseOrders.js";
import Suppliers from "../screens/Suppliers.js";
import StockMovementView from "../screens/StockMovementView.js";
import CreditNote from "../screens/CreditNote.js";
import AddCreditNote from "../screens/AddCreditNote.js";
import Cluster from "../screens/Clusters.js"; 
import AddCluster from "../screens/AddClusters.js";
import PurchasingInvoice from "../screens/PurchasingInvoice.js";

const DashboardLayout = ({ setIsAuthenticated }) => {
  const [activeContent, setActiveContent] = useState({
    content: "user-dashboard", // Default to 'user-dashboard'
    state: {},
  });
  const [isSidebarOpen, setSidebarOpen] = useState(true); // State to manage sidebar visibility
  const [breadcrumbPaths, setBreadcrumbPaths] = useState([
    {
      name: "Home",
      content: "user-dashboard",
      icon: <FaHome />,
      isActive: true,
    },
  ]);
  const navigate = useNavigate();

  // Fetch the username from local storage
  const username = localStorage.getItem("username");

  // UseEffect to check if user is logged in and is Global Admin
  useEffect(() => {
    const validateToken = () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          if (Date.now() >= decodedToken.exp * 1000) {
            localStorage.clear();
            navigate("/login"); // Redirect to login if expired
            return false;
          }
          return true;
        } catch (error) {
          console.error("Invalid token:", error);
          localStorage.clear();
          navigate("/login");
          return false;
        }
      } else {
        navigate("/login");
        return false;
      }
    };

    const interval = setInterval(() => {
      validateToken(); // Periodically check token expiration
    }, 60 * 1000); // Check every minute

    const isAuthenticated = validateToken(); // Validate on component load
    if (!isAuthenticated) return;

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [navigate]);

  // Define the hierarchy of the menu items
  const menuHierarchy = useMemo(
    () => ({
      products: {
        //parent: "master-data",
        name: "Product",
        icon: <FaBox />,
      },
      units: {
        parent: "master-data",
        name: "Unit",
        icon: <FaBalanceScale />,
      },
      organizations: {
        parent: "master-data",
        name: "Organization",
        icon: <FaBuilding />,
      },
     customers: {
        parent: "master-data",
        name: "Customer",
        icon: <FaUserTie />,
      },
      suppliers: {
        parent: "master-data",
        name: "Supplier",
        icon: <FaPeopleCarry />,
      },
      "product-categories": {
        parent: "master-data",
        name: "Product Category",
        icon: <FaTags />,
      },
      locations: {
        parent: "master-data",
        name: "Location",
        icon: <FaLocationArrow />,
      },
      users: {
        parent: "master-data",
        name: "User",
        icon: <FaUsers />,
      },
      "master-data": {
        parent: null,
        name: "Master Data",
        icon: <FaTags />,
      },
      "add-product": {
        parent: "products",
        name: "Add Product",
        icon: <FaPlus />,
      },
      "add-unit": {
        parent: "units",
        name: "Add Unit",
        icon: <FaPlus />,
      },
      "add-organization": {
        parent: "organizations",
        name: "Add Organization",
        icon: <FaPlus />,
      },
      "add-customer": {
        parent: "customers",
        name: "Add Customer",
        icon: <FaPlus />,
      },
      "add-supplier": {
        parent: "suppliers",
        name: "Add Supplier",
        icon: <FaPlus />,
      },
      "add-product-categories": {
        parent: "product-categories",
        name: "Add Product Category",
        icon: <FaPlus />,
      },
      "add-location-categories": {
        parent: "product-categories",
        name: "Add Location Category",
        icon: <FaPlus />,
      },
      "add-adjustment-categories": {
        parent: "product-categories",
        name: "Add Adjustment Category",
        icon: <FaPlus />,
      },
      "add-location": {
        parent: "locations",
        name: "Add Location",
        icon: <FaPlus />,
      },
      "add-user": {
        parent: "users",
        name: "Add User",
        icon: <FaPlus />,
      },
      production: {
        parent: null,
        name: "Production",
        icon: <FaIndustry />,
      },
      "production-batch": {
        parent: "production",
        name: "Production Batch",
        icon: <FaRecycle />,
      },
      "add-production-batch": {
        parent: "production-batch",
        name: "Add Production Batch",
        icon: <FaPlus />,
      },
      "stock-adjustment": {
        parent:"production",
        name: "Stock Adjustment",
        icon: <FaArrowsAltV />,
      },
      "add-stock-adjustment": {
        parent: "stock-adjustment",
        name: "Add Stock Adjustment",
        icon: <FaPlus />,
      },
      orders: {
        parent: null,
        name: "Orders",
        icon: <FaShopify />,
      },
      "order-cycle": {
        parent: "orders",
        name: "Order Cycle",
        icon: <FaFirstOrder />,
      },
      "add-order-cycle": {
        parent: "order-cycle",
        name: "Add Order Cycle",
        icon: <FaPlus />,
      },
      "order-request": {
        parent: "orders",
        name: "Order Requests",
        icon: <FaFirstOrder />,
      },
      "sales-order-invoicing": {
        parent: "order-request",
        name: "Sales Order Invoicing",
        icon: <FaFileInvoiceDollar />,
      },
      "sales-orders":{
        //parent: "order-request",
        name: "Sales-orders",
        icon: <FaFileInvoiceDollar />
      },
      "add-sales-order":{
        parent: "sales-orders",
        name: "Add Sales Order",
        icon: <FaPlus />
      },
      "transfer-orders": {
        parent: "orders",
        name: "Transfer Orders",
        icon: <FaExchangeAlt />,
      },
      "add-transfer-order": {
        parent: "transfer-orders",
        name: "Add Transfer Order",
        icon: <FaPlus />,
      },
      "transfer-order-receipts": {
        parent: "orders",
        name: "Transfer Order Receipt",
        icon: <FaReceipt />,
      },
      "transport-orders": {
        parent: "orders",
        name: "Transport Orders",
        icon: <FaTruck />,
      },
      "add-transport-order": {
        parent: "transport-orders",
        name: "Add Transport Order",
        icon: <FaPlus />,
      },
      "invoices":{
        //parent: "order-request",
        name: "Invoices",
        icon: <LiaFileInvoiceDollarSolid />
      },
      "add-order-request": {
        parent: "order-request",
        name: "Add Order Request",
        icon: <FaFirstOrder/>
      },
      "stock-on-loan" : {
        parent: null,
        name: "Stock On Loan",
        icon: <FaHandHoldingUsd/>
      },
      "dispatched-stock-on-loan": {
        parent: "stock-on-loan",
        name: "Dispatched",
        icon: <FaClipboardCheck />,
      },
      "add-dispatch-stock-on-loan": {
        parent: "dispatched-stock-on-loan",
        name: "Add Disptached Stock On Loan",
        icon: <FaPlus />,
      },
      "received-stock-on-loan": {
        parent: "stock-on-loan",
        name: "Received",
        icon: <FaHandHolding />,
      },
      "add-received-stock-on-loan": {
        parent: "received-stock-on-loan",
        name: "Add Receiving Stock On Loan",
        icon: <FaPlus />,
      },
      "incoming-stock-on-loan": {
        parent: "stock-on-loan",
        name: "Incoming",
        icon: <FaArrowCircleDown />,
      },
      payments: {
        parent: null,
        name: "Payments",
        icon: <MdOutlinePayments/>
      },
      "payment": {
        //parent: payments,
        name: "Paymnet Receipts",
        icon: <MdOutlinePayments/>
      },
      "add-payment-Receipts": {
        parent: "payment",
        name: "Add Payment Receipts",
        icon: <MdOutlinePayments/>
      },
      "credit-note": {
        parent: "payments",
        name: "Credit Note",
        icon: <FaCreditCard/>
      },
      "add-credit-note": {
        parent: "credit-note",
        name: "Add Credit Note",
        icon: <FaPlus/>
      },
      purchasing: {
        parent: null,
        name: "Purchasing",
        icon: <FaShoppingCart/>
      },
      "purchase-orders": {
        parent: "purchasing",
        name: "Purchase Orders",
        icon: <FaShoppingCart/>
      },
      "add-purchase-orders": {
        parent: "purchase-orders",
        name: "Add Purchase Orders",
        icon: <FaPlus/>
      },
      "goods-receipt-note": {
        parent: "purchasing",
        name: "Goods Receipt Note", 
        icon: <FaShoppingCart/>
      },
      "add-grn": {
        parent: "goods-receipt-note",
        name: "Add Goods Receipt Note",
        icon: <FaPlus/>,
      },
      "purchase-invoices": {
        parent: "purchasing",
        name: "Purchase Invoices",
        icon: <FaShoppingCart/>
      },
      "payment": {
        parent: "purchasing",
        name: "Payments",
        icon: <FaShoppingCart/>
      },
      "reports" : {
        parent: null,
        name: "Reports",
        icon: <faIndustry/>
      },
      "stock-view": {
        parent: "reports",
        name: "Stock View",
        icon: <FaWarehouse />,
      },
      "stock-movement": {
        parent: "reports",
        name: "Stock View",
        icon: <FaArrowsAltV />,
      },
      "settelments": {
        parent: "payment",
        name: "Settelments",
        icon: <IoReceiptOutline/>
      },
      "add-settelments": {
        parent: "settelments",
        name: "Add Settelments",
        icon: <IoReceiptOutline/>
      },
      "settings": {
        parent: null,
        name: "Settings",
        icon: <IoSettings/>
      },
      "clusters": {
        parent: "master-data",
        name: "Clusters",
        icon: <FaIndustry />
      },
      "add-cluster": {
        parent: "clusters",
        name: "Add Cluster",
        icon: <FaPlus />,
      },
    }),
    []
  );

  const getContentName = useCallback(
    (content) => {
      return menuHierarchy[content]?.name || "Home";
    },
    [menuHierarchy]
  );

  const getContentIcon = useCallback(
    (content) => {
      return menuHierarchy[content]?.icon || <FaHome />;
    },
    [menuHierarchy]
  );

  const updateBreadcrumbPaths = useCallback(
    (content) => {
      const newPath = {
        name: getContentName(content),
        content,
        icon: getContentIcon(content),
        isActive: true,
      };
      const hierarchy = menuHierarchy[content];
      if (hierarchy && hierarchy.parent) {
        const parentPath = {
          name: getContentName(hierarchy.parent),
          content: hierarchy.parent,
          icon: getContentIcon(hierarchy.parent),
          isActive: false,
        };
        setBreadcrumbPaths((prevPaths) => {
          const rootPath = prevPaths[0]; // Keep the "Home" breadcrumb intact
          return [rootPath, parentPath, newPath];
        });
      } else {
        setBreadcrumbPaths((prevPaths) => {
          const rootPath = prevPaths[0]; // Keep the "Home" breadcrumb intact
          return [rootPath, newPath];
        });
      }
    },
    [getContentName, getContentIcon, menuHierarchy]
  );

  const handleContentChange = useCallback(
    (content, state = {}) => {
      updateBreadcrumbPaths(content);
      setActiveContent({ content, state });
    },
    [updateBreadcrumbPaths]
  );

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const renderContent = useCallback(() => {
    const userRole = localStorage.getItem("role");

    switch (activeContent.content) {
      case "products":
        return userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Accountant" || userRole === "Farm User"? (
          <Products
            onAddProductClick={() => handleContentChange("add-product")}
          />
        ) : (
          <div>Access Denied</div>
        );
      case "user-dashboard":
        return <UserDashboard />;
      case "user-profile":
        return <UserProfile />;
      case "add-product":
        return userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Farm User" ? (
          <AddProduct />
        ) : (
          <div>Access Denied</div>
        );
      case "units":
        return <Units onAddUnitClick={() => handleContentChange("add-unit")} />;
      case "add-unit":
        return <AddUnit />;
      case "organizations":
        return (
          <Organizations
            onAddOrganizationClick={() =>
              handleContentChange("add-organization")
            }
          />
        );
      case "add-organization":
        return <AddOrganization />;
        case "customers":
          return (
            <Customers
              onAddCustomerClick={() => handleContentChange("add-customer")}
            />
          );
          case "suppliers":
            return (
              <Suppliers
                onAddSupplierClick={() => handleContentChange("add-supplier")}
              />
            );
        case "add-customer":
          return <AddCustomer />;
        case "add-supplier":
          return <AddSupplier/>;
        case "product-categories":
          return (
            <ProductCateogry
              onAddProductCategoryClick={() =>
                handleContentChange("add-product-categories")
              }
              onAddLocationCategoryClick={() =>
               handleContentChange("add-location-categories")
              }
              onAddAdjustmentCategoryClick={() =>
               handleContentChange("add-adjustment-categories")
              }
            />
          );
      case "add-product-categories":
        return <AddProductCategory />;
        case "add-location-categories":
        return <AddLocationCategory />;
        case "add-adjustment-categories":
        return <AddAdjustmentCategory />;
      case "locations":
        return (
          <Location
            onAddLocationClick={() => handleContentChange("add-location")}
          />
        );
      case "add-location":
        return <AddLocation />;
      case "users":
        return <Users onAddUserClick={() => handleContentChange("add-user")} />;
      case "add-user":
        return <AddUser />;
      case "production-batch":
        return (
          <ProductBatch
            onAddProductBatchClick={() =>
              handleContentChange("add-production-batch")
            }
          />
        );
      case "add-production-batch":
        return <AddProductionBatch />;
        case "stock-adjustment":
        return (
          <StockAdjustment
            onAddStockAdjustmentClick={() =>
              handleContentChange("add-stock-adjustment")
            }
          />
        );
      case "add-stock-adjustment":
        return <AddStockAdjustment />;
      case "order-cycle":
        return (
          <OrderCycle
            onAddOrderCycleClick={() => handleContentChange("add-order-cycle")}
          />
        );
      case "add-order-cycle":
        return <CreateNewOrderCycle />;
      case "order-request":
        return (
          <OrderRequest
            onInvoicingClick={(orderRequest) =>
              handleContentChange("sales-order-invoicing", {
                orderRequestCode: orderRequest.orderRequestCode,
                orderRequest,
              })
            }
            onAddOrderRequestClick={(orderRequest) =>
              handleContentChange("add-order-request")}
          />
        );
      case "add-order-request" :
      return(
        <AddOrderRequest/>
      );
      case "sales-order-invoicing":
        return (
          <SalesOrderInvoicing
            orderRequestCode={activeContent.state.orderRequestCode}
            orderRequest={activeContent.state.orderRequest}
          />
        );
      case "sales-orders": 
        return(
          <SalesOrders
            onAddSalesOrderClick={() =>handleContentChange("add-sales-order")}
          />
        );
      // case "add-sales-order":
      //   return(
      //     <AddSalesOrder/>
      //   );
      case "transfer-orders": 
        return(
          <TransferOrders
            onAddTransferOrderClick={() => handleContentChange("add-transfer-order")}
          />
        );
      case "add-transfer-order":
        return <AddTransferOrder />;
      case "transfer-order-receipts": 
        return(
          <TransferOrderReceipts
          />
      );
      case "transport-orders": 
        return(
          <TransportOrders
            onAddTransportOrderClick={() => handleContentChange("add-transport-order")}
          />
        );
      case "add-transport-order":
        return <AddTransportOrder />;
      case "invoices":
        return(
          <Invoices/>
        );
        case "dispatched-stock-on-loan":
        return (
          <DispatchedStockOnLoan
            onAddDispatchedStockOnLoanClick={() => handleContentChange("add-dispatch-stock-on-loan")}
          />
        );
      case "add-dispatch-stock-on-loan":
        return <AddDispatchedStockOnLoan />;
        case "incoming-stock-on-loan":
          return <IncomingStockOnLoan 
            onAddReceivedStockOnLoanClick={(stockOnLoan) =>
              handleContentChange("add-received-stock-on-loan", {
                dispatchedStockOnLoanCode: stockOnLoan.dispatchedStockOnLoanCode,
                stockOnLoan,
              })
            }
          />;
        case "received-stock-on-loan":
        return (
          <ReceivedStockOnLoan
            onAddReceivedStockOnLoanClick={() => handleContentChange("add-received-stock-on-loan")}
          />
        );
      case "add-received-stock-on-loan":
        return <AddReceivedStockOnLoan 
          dispatchedStockOnLoanCode={activeContent.state.dispatchedStockOnLoanCode}
          stockOnLoan={activeContent.state.stockOnLoan}
        />;
        case "stock-view":
        return(
          <StockView/>
        );
        case "stock-movement":
        return(
          <StockMovementView/>
        );
        case "payment":
        return userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Farm User" || userRole === "Accountant" ? (
          <PaymentReceipts
          onAddPaymentClick={() => handleContentChange("add-payment-Receipts")}
          />
        ) : (
          <div>Access Denied</div>
        );
        case "add-payment-Receipts":
        return userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Farm User" || userRole === "Accountant" ? (
          <AddPaymentReceipts />
        ) : (
          <div>Access Denied</div>
        );
        case "credit-note":
          return (
            <CreditNote
              onAddCreditNoteClick={() => handleContentChange("add-credit-note")}
            />
          );
        case "add-credit-note":
          return (
            <AddCreditNote />
          );
        case "settelments":
        return userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Farm User" || userRole === "Accountant" ?(
          <Settlements
          onAddSettlementClick={() => handleContentChange("add-settelments")}
          />
        ): (
          <div>Access Denied</div>
        );
        case "add-settelments":
        return userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Farm User" || userRole === "Accountant" ? (
          <AddSettelments />
        ) : (
          <div>Access Denied</div>
        );
        case "purchase-orders" :
        return userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Accountant" ? (
          <PurchaseOrders
            onAddPurchaseOrderClick={() => 
              handleContentChange("add-purchase-orders")
            }

            onAddGRNClick={(order) =>
              handleContentChange("add-grn", {
                orderId: order.id,
                order,
              })
            }
          />
        ) : ( 
          <div>Access Denied</div>
        );
        case "add-purchase-orders" :
          return <AddPurchaseOrder/>;
        case "add-grn":
          return (
            <AddGRN 
              orderId={activeContent.state.orderId} 
              order={activeContent.state.order}
            />
          );
        case "goods-receipt-note" :
        return userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Accountant" ? (
          <GoodReceiptNote/>
        ) : (
          <div>Access Denied</div>
        );
        case "purchase-invoices":
        return userRole === "Main Admin" || userRole === "Company Admin" || userRole === "Outlet User" || userRole === "Accountant" ? (
          <PurchasingInvoice/>
        ) : (
          <div>Access Denied</div>
        );
        case "settings":
          return(
            <Settings/>
          );


      case "stock-on-loan":
        return (
          <div className="text-center text-gray-600">
            <h2 className="text-2xl font-semibold mb-4">Stock On Loan</h2>
            <p className="text-lg">Manage your stock on loan here.</p>
          </div>
        );
      case "clusters":
        return userRole === "Main Admin" || userRole === "Company Admin" ? (
          <Cluster
            onAddClusterClick={() => handleContentChange("add-cluster")}
          />
        ) : (
          <div>Access Denied</div>
        );
      case "add-cluster":
        return userRole === "Main Admin" ? (
          <AddCluster />
        ) : (
          <div>Access Denied</div>
        );
      default:
        return <div>Select a content from the sidebar</div>;
    }
  }, [activeContent, handleContentChange]);

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        className={`${
          isSidebarOpen ? "w-68" : "w-0"
        } transition-all duration-300 bg-gray-800 overflow-y-auto h-screen fixed top-0 left-0`}
      >
        <Sidebar
          onContentChange={handleContentChange}
          onLogout={""} // Fix here
        />
      </div>

      {/* Main Content Area */}
      <div
        className={`flex-1 flex flex-col transition-margin duration-300`}
        style={{
          marginLeft: isSidebarOpen ? "16rem" : "0", // 16rem = 64px (Sidebar width)
          width: isSidebarOpen ? "calc(100% - 16rem)" : "100%",
        }}
      >
        <Navbar
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
          username={username}
          navigateToProfile={() => handleContentChange("user-profile")}
          onLogout={""}
        />
        <main className="flex-1 p-6 bg-gray-100 overflow-auto">
          <Breadcrumb paths={breadcrumbPaths} onClick={handleContentChange} />
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
